import { DSModal } from '@repo/design-system/index'
import { useCurrentUser } from '../../../../../modules/context/UserContext'
import { n_upcoming_lessons } from '../../../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../../../modules/i18n/useTranslation'
import LessonStylePopupBody from '../../../../new-portal/lessons/LessonStylePopupBody'

const LessonStyleModal = ({
  showPopup,
  setShowPopup,
  lessonId,
  isPrestudy = false,
  isConfirmModalOpen = false,
  isWriting,
  response,
}) => {
  const { currentUser } = useCurrentUser()
  const { t } = useTranslation()
  return (
    <>
      {response && (
        <DSModal
          id="lesson-style-popup"
          isOpen={showPopup}
          setIsOpen={setShowPopup}
          size="xl"
          className="max-h-[84vh]"
          closeButton
        >
          <DSModal.Title>{t(n_upcoming_lessons.lesson_style.title)}</DSModal.Title>
          <DSModal.Content className="flex no-scrollbar">
            <LessonStylePopupBody
              lessonId={lessonId}
              item={response.response}
              currentUser={currentUser}
              isConfirmModalOpen={isConfirmModalOpen}
              isWriting={isWriting}
              setShowPopup={setShowPopup}
            />
          </DSModal.Content>
        </DSModal>
      )}
    </>
  )
}

export default LessonStyleModal
